import React, {useState, useContext} from "react";
import { FormControl, TextField, Paper, Typography, Button, Stack, IconButton, RadioGroup, Radio, FormControlLabel } from "@mui/material";
import { Context } from "../../App";
import { API } from "../../conf";
import {Close, Add} from '@mui/icons-material';

export default function EditDonateurForm(props) {
    const { updateConnect } = useContext(Context)
    const [invalid, setInvalid] = useState(false)
    const [msg, setMsg] = useState()
    const [genre, setGenre] = useState(props.donator.genre)
    const [nom, setNom] = useState(props.donator.nom)
    const [prenom1, setPrenom1] = useState(props.donator.prenom1)
    const [prenom2, setPrenom2] = useState(props.donator.prenom2)
    const [mail, setMail] = useState(props.donator.mail)
    const [tel, setTel] = useState(props.donator.tel)
    const [voie, setVoie] = useState(props.donator.voie)
    const [adresse_complement, setComplement] = useState(props.donator.adresse_complement)
    const [zip_code, setZip] = useState(props.donator.zip_code)
    const [ville, setVille] = useState(props.donator.ville)

    function add(donateur) {
        fetch(API.concat(`/eglises/${props.eglise._id}/donateur/${donateur.num}`), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async(response)=>{
            const token = response.headers.get('x-auth-token')
            if (response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const sessionEglise = JSON.parse(sessionStorage.getItem('eglise'))
                    const json = await response.json()
                    props.setEglises(old=>[...old.filter(eglise=>eglise._id!==json._id), json])
                    if (sessionEglise._id===json._id) { sessionStorage.setItem('eglise', JSON.stringify(json))}
                    props.updateDonateurs(donateur)
                    props.updateDonateur(donateur._id)
                }
            }
        })
    }
    
    function handleSubmitNew(event) {
        event.preventDefault()
        if (/(?:^\s+|\s+$)/.test(nom)||/(?:^\s+|\s+$)/.test(prenom1)||(nom.toLowerCase()==='anonyme' && prenom1.toLowerCase()==='anonyme')) {
            setInvalid(true)
            return
        }
        fetch(API.concat('/donateurs/create'), {method:'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify({
                genre: genre,
                nom: nom.toLowerCase(),
                prenom1: prenom1.toLowerCase(),
                prenom2: prenom2?.toLowerCase(),
                mail: mail?.toLowerCase(),
                tel:tel,
                voie: voie,
                zip_code: zip_code,
                ville: ville,
                adresse_complement: adresse_complement
            })
        }).then(async(response)=>{
            setInvalid(false)
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            } else if (token && token !== sessionStorage.getItem('token') && token !== '') {
                sessionStorage.setItem('token', response.headers.get('x-auth-token'))
            }
            if (response.status === 200) {
                const donateur = await response.json()
                add(donateur)
            } if(response.status === 403){
                const text = await response.text()
                setMsg(text)
            }
        })
    }



    return(
        <Paper elevation={2} sx={{ paddingBottom:"30px",paddingX:'15px', display:'flex', flexDirection:'column'}}>
            <IconButton aria-label="fermer" sx={{alignSelf:'flex-end', marginRight:'-15px'}} onClick={props.cancel}>
                <Close/>
            </IconButton>
            <FormControl component='form' onSubmit={handleSubmitNew} error={invalid} hiddenLabel={!invalid}>
                <Typography variant="h5" align="center" sx={{marginBottom:'20px'}}>Modifier un donateur</Typography>
                <Stack direction='row' spacing={1} alignItems='center' sx={{marginBottom:'10px'}}>
                    <RadioGroup row sx={{minWidth:'280px'}}
                    defaultValue={genre}
                    name="radio-buttons-group"
                    onChange={(event)=> setGenre(event.target.value)}
                    >
                        <FormControlLabel value="Mr" control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize:15}}}/>} label="Mr" componentsProps={{typography:{fontSize:15}}} />
                        <FormControlLabel value="Mme" control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize:15}}}/>} label="Mme" componentsProps={{typography:{fontSize:15}}} />
                        <FormControlLabel value="Couple/Famille" control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize:15}}}/>} label="Couple/Famille" componentsProps={{typography:{fontSize:15}}} />
                    </RadioGroup>
                    <TextField
                    sx={{width:'100%', minWidth:'200px'}}
                    required
                    label="Nom"
                    name="nom"
                    autoComplete="family-name"
                    autoFocus
                    value={nom}
                    error={/(?:^\s+|\s+$)/.test(nom)}
                    helperText={/(?:^\s+|\s+$)/.test(nom) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    onChange={(event)=> setNom(event.target.value)}
                    />
                </Stack>
                <Stack direction={'row'} spacing={1} alignItems='center'>
                    <TextField
                    sx={{width:'100%', minWidth:'200px'}}
                    required
                    label="Prénom"
                    autoComplete="given-name"
                    value={prenom1}
                    error={/(?:^\s+|\s+$)/.test(prenom1)}
                    helperText={/(?:^\s+|\s+$)/.test(prenom1) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    onChange={(event)=> setPrenom1(event.target.value)}
                    />
                    {typeof prenom2 === 'string' ?
                    <TextField
                    sx={{width:'100%', minWidth:'200px'}}
                    label="deuxième prénom"
                    name="prenom 2"
                    autoComplete="given-name"
                    value={prenom2}
                    error={/(?:^\s+|\s+$)/.test(prenom2)}
                    helperText={/(?:^\s+|\s+$)/.test(prenom2) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    onChange={(event)=> setPrenom2(event.target.value)}
                    /> :
                    <IconButton aria-label="ajouter un prénom" onClick={()=> setPrenom2('')}>
                        <Add color="primary" fontSize="medium"/>
                    </IconButton>}
                </Stack>
                <Stack direction='row' spacing={1} alignItems='center' sx={{marginTop:'10px'}}>
                    <TextField
                    sx={{width:'100%'}}
                    label="Tél"
                    autoComplete="tel"
                    value={tel}
                    error={/(?:^\s+|\s+$)/.test(tel)}
                    helperText={/(?:^\s+|\s+$)/.test(tel) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    onChange={(event)=> setTel(event.target.value.replace(/[^0-9\s*+#]/gi,''))}/>
                    <TextField
                    sx={{width:'100%'}}
                    label="Email"
                    autoComplete="email"
                    value={mail}
                    error={/(?:^\s+|\s+$)/.test(mail)}
                    helperText={/(?:^\s+|\s+$)/.test(mail) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    onChange={(event)=> setMail(event.target.value)}/>
                </Stack>
                <TextField
                fullWidth
                sx={{marginTop:'10px'}}
                label="N° et libellé de la voie"
                autoComplete="address-line1"
                value={voie}
                onChange={(event)=> setVoie(event.target.value)}/>
                <TextField
                fullWidth
                sx={{marginTop:'10px'}}
                label="Complément d'adresse"
                autoComplete="address-line2"
                value={adresse_complement}
                onChange={(event)=> setComplement(event.target.value)}/>
                <Stack direction='row' spacing={1} alignItems='center' sx={{marginTop:'10px'}}>
                    <TextField
                    sx={{width:'50%'}}
                    label="Code postal"
                    autoComplete="postal-code"
                    value={zip_code}
                    onChange={(event)=> {if(event.target.value.replace(/[^0-9]/gi,'').length<6) setZip(event.target.value.replace(/[^0-9]/gi,''))}}/>
                    <TextField
                    sx={{width:'100%'}}
                    label="ville"
                    autoComplete="address-level2"
                    value={ville}
                    onChange={(event)=> setVille(event.target.value)}/>
                </Stack>
                <Typography variant="info" color='error'>{msg}</Typography>
                {invalid && <Typography color='error' variant="info">Vous ne pouvez pas créer de donateur Anonyme</Typography>}
                <Button type="submit" variant="contained" sx={{alignSelf:'center', paddingX:'30px', marginTop:'10px'}}>Enregistrer</Button>
            </FormControl>
        </Paper>
    )
}